import React from "react";

const Placeholder = ({ className = "" }) => (
    <div aria-hidden="true" className={`rounded-lg bg-slate-200 motion-safe:animate-pulse ${className}`} />
);

export const DashboardTableSkeleton = ({ columns = 5, rows = 5 }) => (
    <>
        {Array.from({ length: rows }, (_, row) => (
            <tr key={row} aria-hidden="true" className="border-t border-slate-100">
                {Array.from({ length: columns }, (_, column) => (
                    <td key={column} className="px-5 py-5">
                        <Placeholder className={column === 0 ? "h-4 w-20" : "h-4 w-full"} />
                    </td>
                ))}
            </tr>
        ))}
        <tr className="sr-only"><td colSpan={columns} role="status">กำลังโหลดข้อมูล...</td></tr>
    </>
);

const DashboardSkeleton = ({ variant = "summary" }) => {
    const overview = variant === "overview";
    const donut = variant === "draftlaw" || variant === "evaluate";
    const filtersOnly = ["summary", "month", "listening"].includes(variant);
    return (
        <div className="min-h-screen bg-[#f3f6fb] pb-16 pt-24" aria-busy="true">
            <p role="status" className="sr-only">กำลังโหลดข้อมูล Dashboard...</p>
            <div className="mx-auto max-w-7xl space-y-6 px-4 sm:px-6 lg:px-8">
                <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <Placeholder className="mb-6 h-5 w-2/5" />
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
                        {Array.from({ length: 5 }, (_, index) => (
                            <div key={index}>
                                <Placeholder className="mb-2 h-3 w-20" />
                                <Placeholder className="h-10 w-full" />
                            </div>
                        ))}
                    </div>
                </section>
                {overview && (
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {Array.from({ length: 6 }, (_, index) => (
                            <section key={index} className={`rounded-2xl border border-slate-200 bg-white p-6 shadow-sm ${index >= 4 ? "lg:col-span-2" : ""}`}>
                                <Placeholder className="mb-5 h-5 w-3/4" />
                                <Placeholder className="mb-6 h-9 w-1/3" />
                                <div className="flex gap-3"><Placeholder className="h-14 flex-1" /><Placeholder className="h-14 flex-1" /><Placeholder className="h-14 flex-1" /></div>
                            </section>
                        ))}
                    </div>
                )}
                {!filtersOnly && <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <Placeholder className="mb-8 h-5 w-1/2" />
                    {donut ? (
                        <div className="flex flex-col items-center gap-8 md:flex-row">
                            <div aria-hidden="true" className="h-44 w-44 shrink-0 rounded-full border-[28px] border-slate-200 motion-safe:animate-pulse" />
                            <div className="grid w-full flex-1 grid-cols-2 gap-5 lg:grid-cols-5">
                                {Array.from({ length: 10 }, (_, index) => <Placeholder key={index} className="h-12" />)}
                            </div>
                        </div>
                    ) : (
                        <div aria-hidden="true" className="flex h-56 items-end justify-around gap-4 border-b border-l border-slate-200 px-5">
                            {[40, 65, 50, 80, 55, 90].map((height, index) => (
                                <div key={index} style={{ height: `${height}%` }} className="w-full rounded-t-lg bg-slate-200 motion-safe:animate-pulse" />
                            ))}
                        </div>
                    )}
                </section>}
                {!filtersOnly && !overview && <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <Placeholder className="mb-6 h-5 w-2/3" />
                    <div className="overflow-x-auto">
                        <table className="w-full" aria-label="กำลังโหลดตารางผลลัพธ์">
                            <tbody><DashboardTableSkeleton columns={6} /></tbody>
                        </table>
                    </div>
                </section>}
            </div>
        </div>
    );
};

export default DashboardSkeleton;
